export default function (Site, $) {
  Site.widget("checkout-form", {
    _create() {
      if (this.options.delivery) {
        this.selection = this.element.find('select[name="billing_state"]');
        this.message = $("<p></p>");

        jQuery(this.selection).on("change", () => {
          this.update();
        });
        this.update();

        this.int = setInterval(() => {
          this.update();
        }, 800);
      }

      let blocked;
      if (this.options.blocked) {
        blocked = this.options.blocked.map((item) => {
          return item.order_location + item.order_date + item.order_timeslot;
        });
      }

      jQuery(this.element).on("input, change", () => {
        let location = this.element
          .find('[name="_pickup_location"]:checked')
          .val();
        let date = this.element.find('[name="_pickup_date"]:checked').val();
        let time = this.element.find('[name="_pickup_time"]:checked').val();

        let parts = [];

        if (location) parts.push(location);
        if (date) parts.push(date);
        if (time) parts.push(time);

        this.element
          .find('[name="_pickup_time"]')
          .get()
          .forEach((el) => {
            if (this.options.blocked) {
              el.disabled = blocked.includes(location + date + el.value);
              let label = $(`label[for="${el.id}"]`);
              label.prop(
                "title",
                el.disabled
                  ? `${location} ${date} ${el.value} not available`
                  : ""
              );
              if (el.disabled) {
                el.checked = false;
              }
            }
          });
      });

      this.checkMinimumOrder();
    },

    _destroy() {
      clearInterval(this.int);
    },

    update() {
      requestAnimationFrame(() => {
        const val = this.selection.val();

        const whitelist = ["ACT"];
        const enabled = whitelist.includes(val);

        $('button[type="submit"]').prop("disabled", !enabled);
        this.message.text(
          `Sorry we only deliver to ${
            whitelist.length === 1 ? "the " : ""
          }${list(whitelist)} for now`
        );

        this.message.css("display", enabled ? "none" : "");
        $("small.woocommerce-conditions").append(this.message);
      });
    },

    checkMinimumOrder() {
      const minAmount = 250;
      if (parseFloat(this.element[0].dataset.subtotal) < minAmount) {
        document
          .querySelector("form.checkout")
          .classList.add("minimum-not-reached");

        setTimeout(() => {
          document.getElementById("place_order").disabled = true;
        }, 3000);
      }
    },
  });
}

function list(arr) {
  if (!arr.length) return "";
  if (arr.length === 1) return arr[0];

  let array = [...arr];
  let last = array.pop();
  return array.join(", ") + " and " + last;
}
